import React, { Component, PropTypes } from 'react';
import { Button } from 'react-bootstrap';
import * as Api from 'api';

class DownloadContactsButton extends Component {
  static propTypes = {
    coords: PropTypes.arrayOf(PropTypes.number).isRequired,
    onError: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired
  }
  state = {
    loading: false
  }
  constructor(props) {
    super(props);
    this.handleDownloadNearbyContacts = this.handleDownloadNearbyContacts.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
  }
  handleDownloadNearbyContacts() {
    this.setState({ loading: true });
    Api
      .fetchContactsNear(this.props.coords)
      .then(this.handleDownload)
      .catch(this.handleError);
  }
  handleDownload(res) {
    this.setState({ loading: false });
    this.props.onDownload(res.data);
  }
  handleError(error) {
    this.setState({ loading: false });
    this.props.onError(error);
  }
  render() {
    if(!this.props.coords) {
      return null;
    }
    const props = { ...this.props, coords: undefined };
    return (
      <Button onClick={f => this.state.loading? null : this.handleDownloadNearbyContacts()} bsStyle='default' {...props}>
        {this.state.loading ? (
          <span>
            <i className="fa fa-spinner fa-spin"></i> Searching...
          </span>
        ) : (
          <span>
            <i className="fa fa-users"></i>{' '}
            Nearby Contacts
          </span>
        )}
      </Button>
    );
  }
}

export default DownloadContactsButton;



// WEBPACK FOOTER //
// ./src/browser/components/clients/download-contacts-button.js